export const EXPLORE_ACCOUNT_OPTION_OFF = 'off';

export type AccountExploreOptions = {
  explore?: typeof EXPLORE_ACCOUNT_OPTION_OFF;
};

export type AccountWithExploreOptions = {
  options?: AccountExploreOptions | null;
};

export function isAccountExploreDisabled(
  account: AccountWithExploreOptions | undefined | null
): boolean {
  return account?.options?.explore === EXPLORE_ACCOUNT_OPTION_OFF;
}
